module.exports = __webpack_public_path__ + "static/media/arrow-right-outline-color.249ac9fe.svg";